(function() {
  var DURATION = 20 * 60;
  var STORAGE_KEY = 'eb_countdown_end_' + window.location.pathname;

  function getEndTime() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        var end = parseInt(stored, 10);
        if (end > Date.now()) return end;
      }
    } catch(e) {}
    var newEnd = Date.now() + DURATION * 1000;
    try { localStorage.setItem(STORAGE_KEY, newEnd); } catch(e) {}
    return newEnd;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function updateTimers(h, m, s) {
    ['h1','h2'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = pad(h);
    });
    ['m1','m2'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = pad(m);
    });
    ['s1','s2'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.textContent = pad(s);
    });
  }

  function startCountdown() {
    var endTime = getEndTime();
    function tick() {
      var remaining = Math.floor((endTime - Date.now()) / 1000);
      if (remaining <= 0) {
        // Reset timer
        try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
        endTime = Date.now() + DURATION * 1000;
        try { localStorage.setItem(STORAGE_KEY, endTime); } catch(e) {}
        remaining = DURATION;
      }
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      updateTimers(h, m, s);
    }
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCountdown);
  } else {
    startCountdown();
  }
})();
